import {Component, OnInit, Input, Optional, Self, ViewChild} from '@angular/core';
import {NgControl} from '@angular/forms';
import {BaseAnswerTypeComponent} from "../base-answer-type.component";
import {FileDto} from "../../../../models/file";
import {PublicFilesService} from "../../../../services/public-files.service";
import {finalize} from "rxjs/operators";
import {MatTableDataSource} from "@angular/material/table";
import { ComparableOperator, PosibleAnswer } from '@app/models/form';
import { SimpleFileUploaderComponent } from '@app/views/pages/simple-file-uploader/simple-file-uploader.component';
import { NotificationService } from '@app/services/notification.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-template-input',
  templateUrl: './template-input.component.html',
  styleUrls: ['./template-input.component.scss'],
})
export class TemplateInputComponent extends BaseAnswerTypeComponent<number> implements OnInit {
  @Input() maxLength: number = 200;
  @Input() placeholder: string = '';
  @Input() label: string = '';
  @Input() readonly: boolean = false;

  @Input() initialData: FileDto[];
  @Input() templateId: number;

  @Input() uploadEndpoint: string;

  @Input() allowedExtensions = '.png,.jpg,.jpeg,.pdf,.docx,.xls,.xlsx,.webp,.webm';
  @ViewChild('fileUploader') fileUploader: SimpleFileUploaderComponent;
  filesData: Partial<FileDto>[] = [];

  displayedColumns = [
    "name",
    "type",
    "size",
    "remove",
  ];
  matDatasource = new MatTableDataSource([]);


  readonly defaultValue = -1;
  public downloading = false;

  constructor(
    private toast: NotificationService,
    private translate: TranslateService,
    @Optional() @Self() ngControl?: NgControl,
    private uploadFileService?: PublicFilesService
  ) {
    super(ngControl);
  }

  ngOnInit() {
    this.uploadEndpoint = `FileStorage/UploadFileFormTemplateAnswer`;
    console.log(this.templateId);
  }


  ngAfterViewInit() {
    super.ngAfterViewInit();

    this.fileUploader.changes.subscribe(files => {
      const fileID = files[0]?.id || this.defaultValue;
      this.updateValue(fileID);
      this.matDatasource.data = [...files];
    });

    this.matDatasource.data = this.initialData;
  }

  downloadTemplate() {
    if (!this.templateId) {
      this.toast.openSnackBar(this.translate.instant('FILE-MANAGER.TABLE.EMPTY'));
      return;
    }
    this.downloading = true;
    this.uploadFileService.downloadFileTemplate(this.templateId)
      .pipe(
        finalize(() => this.downloading = false),
      ).subscribe();
  }

  AllowedOperators: {[K in ComparableOperator]: (t: number, value: any) => boolean} = {
    [ComparableOperator.Equal]: null,
    [ComparableOperator.NotEqual]: null,
    [ComparableOperator.Contains]: null,
    [ComparableOperator.StartWith]: null,
    [ComparableOperator.EndWith]: null,
    [ComparableOperator.In]: null,
    [ComparableOperator.GreaterThan]: null,
    [ComparableOperator.GreaterThanOrEqual]: null,
    [ComparableOperator.LessThan]: null,
    [ComparableOperator.LessThanOrEqual]: null,
    [ComparableOperator.IsNullOrEmpty]: (target) => !target,
    [ComparableOperator.NotIsNullOrEmpty]: (target) => !!target,
    [ComparableOperator.Between]: null,
  }
}
